<template>
  <div>
    <v-card class="rounded-lg" flat>
      <v-card-title class="px-10 pt-8">
        <p>{{ $t('organization.details.tabs.gateways.title') }}</p>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <template>
          <v-list>
            <v-list-item>
              <v-list-item-content class="ml-10">
                <v-list-item-title>
                  <v-icon color="black" class="pr-1" v-if="validPayments">
                    check_circle
                  </v-icon>
                  <span>
                    {{ computedPayments.name }}
                  </span>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action class="mx-4">
                <v-btn
                  color="grey"
                  icon
                  class="text--darken-3"
                  @click="togglePaymentsConfig(true)"
                >
                  <v-icon size="28">edit_square</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </template>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "organizationGateways",
  data() {
    return {};
  },
  created() {},
  computed: {
    ...mapState({
      organizationGateways: ({ organization: { organization } }) =>
        organization.gateways
    }),
    validPayments() {
      const isPayments = this.getIsPayment();
      if (isPayments && isPayments.api_keys) {
        return true;
      } else {
        return false;
      }
    },
    computedPayments() {
      const isPayments = this.getIsPayment();
      if (isPayments) {
        return {
          name: isPayments.gateway.name,
          id: isPayments.gateway.id,
          api_keys: isPayments.api_keys
        };
      } else {
        return {
          name: "Recurrent Payments",
          id: 18,
          api_keys: {
            api_key: null
          }
        };
      }
    }
  },
  methods: {
    ...mapMutations({
      togglePaymentsConfig: "organization/togglePaymentsConfig"
    }),
    getIsPayment() {
      return (
        this.organizationGateways &&
        this.organizationGateways.find(
          ({ gateway }) => gateway.name === "Recurrent Payments"
        )
      );
    }
  }
};
</script>

<style lang="scss" scoped></style>
